import { useTranslation } from '@thoughtspot/i18n';
import { Button } from '@thoughtspot/radiant-react/widgets/button';
import { IconID } from '@thoughtspot/radiant-react/widgets/icon';
import { NoData } from '@thoughtspot/radiant-react/widgets/no-data';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import { isIamV2OidcEnabled } from '@thoughtspot/session-service';
import cx from 'classnames';
import React from 'react';
import { Vertical } from "../../../utils/layouts";
import { IDP_LIST, IDP_TYPE, TranslationsKeys } from '../constant';
import styles from './add-identity-provider.module.scss';
export const AddIdentityProvider = ({ onAddProviderClick, }) => {
    const { t } = useTranslation();
    const getTranslations = (key, args) => t(`${key}`, args);
    return !isIamV2OidcEnabled() ? (React.createElement("div", { className: styles.samlProviderOuterContainer },
        React.createElement("div", { className: styles.providerInnerContainer },
            React.createElement("div", { className: styles.samlLogoImage },
                React.createElement(NoData, { "data-testid": "addSamlImage", imageSrc: "/resources/img/saml-logo.svg" })),
            React.createElement("div", { className: styles.buttonContainer },
                React.createElement(Typography, { variant: "h2", noMargin: true }, getTranslations(TranslationsKeys.SAML_CONFIG_TEXT)),
                React.createElement(Typography, { variant: "p-large", noMargin: true }, getTranslations(TranslationsKeys.SAML_CONFIG_MESSAGE)),
                React.createElement(Button, { "data-testid": "addSamlButton", text: getTranslations(TranslationsKeys.ADD_BUTTON), icon: IconID.PLUS, onClick: () => onAddProviderClick(IDP_TYPE.SAML), className: styles.AddButtonMarginTop }))))) : (React.createElement("div", { className: styles.providerOuterContainer }, IDP_LIST.map(element => {
        return (React.createElement(Vertical, { key: element.type, className: styles['grid-item'], "data-testid": element.type, onClick: () => onAddProviderClick(element.type), tabIndex: 0, onKeyDown: e => {
                if (e.key === 'Enter') {
                    onAddProviderClick(element.type);
                }
            } },
            React.createElement("img", { className: cx(styles.logo, {
                    [styles.samlWidth]: element.type === IDP_TYPE.SAML,
                }), src: element.image, alt: element.title }),
            React.createElement("p", null, getTranslations(`saml.idp.${element.type}`))));
    })));
};
//# sourceMappingURL=add-identity-provider.js.map